// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"902":"c5876da1","961":"6925b0bd"}[chunkId] + ".chunk.css";
};